module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "display": "flex"
    }
  }, [_c('v-combobox', {
    staticStyle: {
      "flex-grow": "1"
    },
    attrs: {
      "items": _vm.commonRanges.map(function (o) { return o.text; }),
      "label": _vm.label,
      "xxxappend-outer-icon": "event"
    },
    model: {
      value: (_vm.rangeText),
      callback: function($$v) {
        _vm.rangeText = $$v
      },
      expression: "rangeText"
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "padding": "18px 0 0 5px"
    }
  }, [_c('v-icon', {
    on: {
      "click": _vm.showCalendar
    }
  }, [_vm._v("event")])], 1), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "max-width": "290"
    },
    model: {
      value: (_vm.dialogVisible),
      callback: function($$v) {
        _vm.dialogVisible = $$v
      },
      expression: "dialogVisible"
    }
  }, [_c('div', {
    staticClass: "white-background",
    on: {
      "click": _vm.closeIfApplicable
    }
  }, [_c('div', {
    staticClass: "pa-3 primary white--text"
  }, [_vm._v("\n                " + _vm._s(_vm.dialogTitle) + "\n            ")]), _vm._v(" "), (_vm.dialogVisible) ? _c('v-date-picker', {
    attrs: {
      "range": "",
      "no-title": "",
      "locale": "en-AU"
    },
    model: {
      value: (_vm.pickerDates),
      callback: function($$v) {
        _vm.pickerDates = $$v
      },
      expression: "pickerDates"
    }
  }) : _vm._e()], 1)])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5ffdc6c0"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/ui-elements/DateRange.vue
// module id = 2577
// module chunks = 1